import {
    setStore,
    getStore,
    getQuery
} from "@/utils";
import Axios from 'axios';
const user = {
    state: {
        userInfo: getStore({
            name: 'userInfo',
            type: 'session'
        }) || {},
        expires_in: getStore({
            name: 'expires_in',
            type: 'session'
        }) || '',
        access_token: getStore({
            name: 'access_token',
            type: 'session'
        }) || '',
        refresh_token: getStore({
            name: 'refresh_token',
            type: 'session'
        }) || '',
        pageLoading: getStore({
            name: 'pageLoading',
            type: 'session'
        }) || true,
    },

    getters: {
        pageLoading: state => state.pageLoading,
    },

    mutations: {
        SET_ACCESS_TOKEN: (state, accessToken) => {
            state.access_token = accessToken
            setStore({
                name: 'access_token',
                content: state.access_token,
                type: 'session'
            })
        },
        SET_EXPIRES_IN: (state, expiresIn) => {
            state.expires_in = expiresIn
            setStore({
                name: 'expires_in',
                content: state.expires_in,
                type: 'session'
            })
        },
        SET_REFRESH_TOKEN: (state, rfToken) => {
            state.refresh_token = rfToken
            setStore({
                name: 'refresh_token',
                content: state.refresh_token,
                type: 'session'
            })
        },
        SET_USER_INFO: (state, userInfo) => {
            state.userInfo = userInfo
            setStore({
                name: 'userInfo',
                content: userInfo,
                type: 'session'
            })
        },
        SET_PAGE_LOADING: (state, bol) => {
            state.pageLoading = bol
            setStore({
                name: 'pageLoading',
                content: bol,
                type: 'session'
            })
        },
    },

    actions: {
        // 如果是设计软件内嵌页面，且地址栏带有tokenId，校验token的时候，接口header不传内容
        // 如果是前台页面，且地址栏带有tokenId，校验token的时候，接口header 传Authorization: Basic YmJzOmJicw==
        handleCheckToken({
            commit,
            state
        }, params) {
            return new Promise((resolve, reject) => {
                Axios.get('/apiV1/admin/user/checkCaxaToken', {
                    params: {
                        tokenId: params.tokenId
                    },
                    headers: {
                        isToken: false,
                        Authorization: 'Basic amlhanV2aWRlbzpqaWFqdXZpZGVv'
                    }
                }).then(response => {
                    const data = response.data
                    if (data.code === 0 && data.data) {
                        if(data.data.access_token) {
                            commit('SET_ACCESS_TOKEN', data.data.access_token)
                            commit('SET_REFRESH_TOKEN', data.data.refresh_token)
                            commit('SET_EXPIRES_IN', data.data.expires_in)
                            commit('SET_USER_INFO', data.data.user_info)
                        }
                    } else {
                        const tokenId = getQuery("tokenId");
                        commit('SET_ACCESS_TOKEN', tokenId)
                    }
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        setPageLoading({
            state,
            commit
        }, bol) {
            commit('SET_PAGE_LOADING', bol)
        }
    }
}

export default user


// WEBPACK FOOTER //
// ./src/store/module/user.js